import type { ErrorItem, ErrorsListParams } from '@/types';

import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';

import { createPaginationParams, createTableQueryOptions } from '@/components/table';
import { apiClient } from '@/utils/api';
import { buildApiParams } from '@/utils/helpers';

// Atom for errorz list parameters
export const errorzListParamsAtom = atom<ErrorsListParams>({
  page: 1,
  per_page: createPaginationParams().per_page,
  filters: {}
});

// Hydration flag to delay initial query until URL/filters are synced
export const errorzHydratedAtom = atom<boolean>(false);

// Main errorz query atom
export const errorzQueryAtom = atomWithQuery((get) => {
  const params = get(errorzListParamsAtom);
  const hydrated = get(errorzHydratedAtom);

  return createTableQueryOptions({
    queryKey: ['errorz', params] as const,
    queryFn: async () => {
      const apiParams = buildApiParams(
        {
          page: params.page,
          per_page: params.per_page
        },
        params.filters
      );

      // await new Promise((resolve) => setTimeout(resolve, 100000));
      const { data } = await apiClient.get<{
        success: boolean;
        message: string;
        data: ErrorItem[];
        meta: {
          total: number;
          per_page: number;
          current_page: number;
          last_page: number;
        };
      }>('/errorz', { params: apiParams });

      return data;
    },
    enabled: hydrated
  });
});

